import React, { Suspense } from "react";
import { Skeleton } from "antd";
import { EnterprisePage } from '@rankmi/ats-app'

const EnterpriseLanding = ({ enterpriseSlug, tenantId }) => {
  const skeleton = () => {
    return (
      <Skeleton
        title={true}
        active={true}
        paragraph={{ rows: 6 }}
      />
    );
  };

  return (
    <Suspense fallback={skeleton()}>
      <div className="organization-page-container">
        <EnterprisePage
          enterpriseSlug={enterpriseSlug}
          tenantId={tenantId}
        />
      </div>
    </Suspense>
  );
};

export default EnterpriseLanding;
